import { render, staticRenderFns } from "./AmazeCardLink.vue?vue&type=template&id=01e683a4&scoped=true"
import script from "./AmazeCardLink.vue?vue&type=script&lang=js"
export * from "./AmazeCardLink.vue?vue&type=script&lang=js"
import style0 from "./AmazeCardLink.vue?vue&type=style&index=0&id=01e683a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e683a4",
  null
  
)

export default component.exports